var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-table",
    {
      attrs: {
        data: _vm.tableData,
        loading: _vm.loading,
        "element-loading-text": "正在加载中～",
        pagination: _vm.pageState,
        "max-height": "400",
      },
      on: { onChange: _vm.onTableChange },
    },
    [
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "orderNo",
          label: "订单号",
          width: "250",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "right",
                      effect: "dark",
                      trigger: "hover",
                      tabindex: "1",
                      "hide-after": "800",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyOrderNo(row.orderNo)
                                    },
                                  },
                                },
                                [_vm._v("复制")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "color-mainColor pointer",
                        on: {
                          click: function ($event) {
                            return _vm.handleDetail(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.orderNo))]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "orderDepart",
          label: "预计出行时间",
          width: "180",
        },
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "typeName", label: "类型" },
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "statusName", label: "订单状态" },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "startAddress",
          label: "出发地",
          width: "200",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "endAddress",
          label: "目的地",
          width: "180",
          "show-overflow-tooltip": "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "createTime",
          label: "接单时间",
          width: "180",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "supervisor",
          label: "出发接人",
          width: "200",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col",
                    on: {
                      click: function ($event) {
                        return _vm.situationDetail(row.one, "one")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.one ? row.one.operationTime : "")),
                    ]),
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.one ? row.one.location : "")),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "supervisor",
          label: "到达上车点",
          width: "200",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col",
                    on: {
                      click: function ($event) {
                        return _vm.situationDetail(row.two, "two")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.two ? row.two.operationTime : "")),
                    ]),
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.two ? row.two.location : "")),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "supervisor",
          label: "乘客上车",
          width: "200",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col",
                    on: {
                      click: function ($event) {
                        return _vm.situationDetail(row.three, "three")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.three ? row.three.operationTime : "")),
                    ]),
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.three ? row.three.location : "")),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "supervisor",
          label: "到达目的地",
          width: "200",
          "show-overflow-tooltip": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col",
                    on: {
                      click: function ($event) {
                        return _vm.situationDetail(row.four, "four")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.four ? row.four.operationTime : "")),
                    ]),
                    _c("span", { staticClass: "situation pointer" }, [
                      _vm._v(_vm._s(row.four ? row.four.location : "")),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }